<script>
import Base from './base.vue';
import { ZOOM_MEETING_PRO_MIN_LICENSE, planTypes, BILLING_CYCLE } from '@/common/constants';
import { mapGetters } from 'vuex';
import { computedCallingPlans, computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import { getZPCallingFeesText } from '@/plans/ZOOM_PHONE/helper/utils';
import { plansof } from '@/utils/chain';
export default {
  name: 'Upgrade',
  extends: Base,
  computed: {
    ...mapGetters(['boughtPlans']),
    minCallingPlan() {
      return this.minHostAndReason.min;
    },
    maxCallingPlan() {
      return 9999;
    },
    showAddAnotherRegionCTA() {
      return false;
    },
    currentEditBizPlus() {
      return this.getSelectedPlans.find(p => p.type === planTypes.ZOOM_ONE_BUNDLE);
    },
    minHostAndReason() {
      const boughtMeetingPlanLicense = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0)?.cartInfo?.selected_number ?? 0;
      const boughtPropPlanLicense = plansof(this.boughtPlans).type(planTypes.ZONE_PRO_PLUS).get(0)?.cartInfo?.selected_number ?? 0;
      const min =  Math.max(boughtMeetingPlanLicense, boughtPropPlanLicense, ZOOM_MEETING_PRO_MIN_LICENSE);
      return {
        reason: '',
        min
      }
    },
    licenseTips() {
      return this.minHostAndReason.reason;
    },
    showCycle() {
      // if has purchased zp base plan, return false
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? false;
      if (basePlan) {
        return false;
      }
      return true;
    },
    planBillInfo() {
      if (this.showCycle) return false;
      const plan = computedCallingPlans(this.boughtPlans)?.[0] ?? {};
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? {};
      const payment = getZPCallingFeesText(basePlan).title;
      const billingCycle = basePlan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO ? BILLING_CYCLE.MONTHLY : plan.billing_cycle;
      return {
        billing_cycle: billingCycle,
        payment
      }
    },
    planDetailLabel() {
      // from pricing page upgrade CTA
      if (this.$context.is.prop2bundle || this.$context.is.pro2bundle || this.$context.is.biz2bundle) return false;
      return this.$t('billing.plan_details');
    }
  }
}
</script>
